// AUTO-GENERATED by scripts/precompile-validators.cjs. Do not edit by hand.
/* eslint-disable */
import * as cmdb_application_schema_v1_06daef8c from './cmdb_application_schema_v1_06daef8c';

type ValidatorFn = ((data: unknown) => boolean) & { errors?: unknown };

export const precompiledValidatorFns: Record<string, Record<string, ValidatorFn>> = {
  'cmdb_application_schema-v1': cmdb_application_schema_v1_06daef8c as unknown as Record<string, ValidatorFn>,
};
